import {
  Briefcase,
  LayoutDashboard,
  LogOut,
  Menu,
  ShieldCheck,
  Users,
  X,
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useState } from "react";

const Sidebar = () => {
  const { logout, user } = useAuth();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
  };

  const menuItems = [
    { label: "Dashboard", icon: LayoutDashboard, path: "/dashboard" },
    { label: "Projects", icon: Briefcase, path: "/projects" },
    ...(user?.role === "admin"
      ? [{ label: "Users", icon: Users, path: "/users" }]
      : []),
  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden w-64 bg-card border-r md:flex flex-col shrink-0">
        <div className="h-16 flex items-center px-6 gap-3 border-b">
          <div className="p-1.5 bg-black rounded-md">
            <ShieldCheck className="h-6 w-6 text-white" />
          </div>
          <span className="font-bold text-sm tracking-tight">
            OpsBoard Lite_Admin Dashboard
          </span>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={
                location.pathname === item.path
                  ? "flex items-center gap-3 px-3 py-2 bg-gray-100 rounded-md transition-colors font-medium hover:bg-gray-200 hover:text-black"
                  : "flex items-center gap-3 px-3 py-2 rounded-md transition-colors font-medium hover:bg-gray-200 hover:text-black"
              }
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="p-4 border-t">
          <button
            onClick={handleLogout}
            className="w-full flex items-center px-3 py-2 rounded-md  transition-colors font-medium hover:bg-gray-200 hover:text-black"
          >
            <LogOut className="h-5 w-5 mr-3" />
            Logout
          </button>
        </div>
      </div>

      {/* Mobile Navbar */}
      <div className="md:hidden fixed top-0 left-0 right-0 bg-white border-b z-50">
        <div className="h-16 flex items-center justify-between px-4">
          <div className="flex items-center gap-3">
            <div className="p-1.5 bg-black rounded-md">
              <ShieldCheck className="h-5 w-5 text-white" />
            </div>
            <span className="font-bold text-sm">OpsBoard</span>
          </div>
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="p-2"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <nav className="bg-white border-t space-y-1 p-4">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={
                  location.pathname === item.path
                    ? "flex items-center gap-3 px-3 py-2 bg-gray-100 rounded-md transition-colors font-medium"
                    : "flex items-center gap-3 px-3 py-2 rounded-md transition-colors font-medium hover:bg-gray-100"
                }
              >
                <item.icon className="h-5 w-5" />
                {item.label}
              </Link>
            ))}
            <button
              onClick={() => {
                handleLogout();
                setMobileMenuOpen(false);
              }}
              className="w-full flex items-center gap-3 px-3 py-2 rounded-md transition-colors font-medium hover:bg-gray-100 text-red-600"
            >
              <LogOut className="h-5 w-5" />
              Logout
            </button>
          </nav>
        )}
      </div>
    </>
  );
};

export default Sidebar;
